﻿export default class SignStatus extends HTMLDivElement {

    constructor() {
        super();
        this.polling = false;
        this.interval = null;
        this.pollDelay = 1000;
    }


    get serviceUrl() {
        return this.dataset.serviceUrl;
    }

    get bankIdUrl() {
        return this.dataset.bankidUrl;
    }

    get autostart() {
        return this.dataset.autostart;
    }

    get startbuttonDelay() {
        return Number(this.dataset.startbuttonDelay);
    }

    isAndroid() {
        return navigator.userAgent.toLowerCase().indexOf("android") > -1;
    }

    updateStatus() {
        if (!this.polling) {

            this.polling = true;

            $.ajax({
                cache: false,
                url: this.serviceUrl,
                dataType: "json",
                success: this.statusReceived.bind(this),
                error: function () {
                    console.log("error");
                    polling = false;
                }
            });
        };
    }

    tryStartBankIdApp() {
        location.href = this.bankIdUrl;
    }

    statusReceived(response) {

        if (response.Message) {
            $("#login-status").html(response.Message);
        }

        $("#bankIdQrCode").attr("src", response.QrSrcCode);

        if (response.ShowStartButton) {
            $("[data-autostart-group='autostart']").removeClass("hidden");
        } else {
            $("[data-autostart-group='autostart']:not(.hidden)").addClass("hidden");
        }

        if (response.CancelPoll) {
            $(".load-container").hide();
            window.clearInterval(this.interval);
        } else {
            this.polling = false;
        }

        if (response.ReturnUrl) {
            window.setTimeout(function () {
                location.href = response.ReturnUrl;
            }, this.pollDelay);
        } 

    }

    connectedCallback() {
        this.interval = window.setInterval(this.updateStatus.bind(this), this.pollDelay);

        if (this.autostart === "true") {
            if (!this.isAndroid()) {
                setTimeout(this.tryStartBankIdApp(), 1000);
                setTimeout(function () {
                    $(".autostart-wrapper").removeClass("hidden");
                }, this.startbuttonDelay * 1000);
            } else {
                $(".autostart-wrapper").removeClass("hidden");
            }
        }

        $("#btn-start-bankid").on("click", function () {
            $(this).attr("disabled", "disabled");
        });
    }

}

customElements.define('sign-status', SignStatus, { extends: "div" });